import {Component, OnInit} from '@angular/core';
import {GeneralService} from 'src/app/service/general-service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {TableSelectionAbstract} from 'src/app/shared/component/table/table-selection.abstract';
import {NotificationService} from 'src/app/service/notification.service';
import {Constant} from 'src/app/shared/constants/constant.class';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigService} from 'src/app-config.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {WarehouseService} from '../../../../../service/warehouse.service';

@Component({
  selector: "app-export-warehouse-chemical",
  templateUrl: "./export-warehouse-chemical.component.html",
  styleUrls: ["./export-warehouse-chemical.component.scss"],
})
export class ExportWarehouseChemicalComponent
  extends TableSelectionAbstract
  implements OnInit
{
  datas: any[] = [];
  data: any;
  loading: any;
  page: any;
  pageSize: any;
  defaultPage: any;
  checkDelete = true;
  checkUpdate = true;
  checkDetails = true;
  isVisibleAdd: boolean;
  enableEdit: boolean;
  searchText: any;
  checkAdd = true;
  chemicals: any[] = [];
  machines: any[] = [];
  filterData: any[];
  detailItems: any[];
  selectedData: any;
  scanBarcodeDefault: boolean;
  isEdit: boolean;
  viewOnly: boolean;
  loadingButton: boolean;
  selectedWarehouse: any;
  selectedWarehouseId: any;
  warehouses: any[] = [];
  isMaster: boolean = false;
  disableComplete: boolean = true;
  constructor(
    private generalService: GeneralService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private configService: AppConfigService,
    private warehouseService: WarehouseService,
    private fb: FormBuilder
  ) {
    super("id");
    this.detailItems = [];
    this.enableEdit = true;
    this.scanBarcodeDefault = true;
    this.selectedData = {
      id: 0,
      code: "",
      description: "",
      receiveType: 1,
      recipient: "",
      warehouseExportDetails: [],
      scanBarcode: this.scanBarcodeDefault,
      receiverName: "",
      importerName: "",
    };
  }

  ngOnInit(): void {
    this.pageSize = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPage = this.configService.getConfig().defaultPage;
    this.get();
    this.getCheckedIdList();
    this.getMachine();
    this.getListData();
    this.getSelectedWarehouse();
    this.getUserWarehouses();
    this.isMaster =
      +localStorage.getItem(Constant.WAREHOUSE_ID) === 1 ? true : false;
  }
  getUserWarehouses() {
    const userInfo = JSON.parse(localStorage.getItem(Constant.USER_INFO));
    console.log(userInfo);
    this.warehouseService.getWarehousesByUserId(userInfo.id).subscribe(
      (res) => {
        this.warehouses = res;
      },
      (error) => {}
    );
  }

  getSelectedWarehouse() {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.warehouseService.getWarehouseById(this.selectedWarehouseId).subscribe(
      (res) => {
        this.selectedWarehouse = res;
      },
      (error) => {}
    );
  }
  getListData() {
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    this.loading = true;
    const filter = {
      receiveType: 0,
      recipient: null,
      chemicalName: null,
      page: 1,
      pageSize: 100,
      fromWareHouseId: this.selectedWarehouseId,
    };
    this.generalService.getWarehouseExport(filter).subscribe(
      (res) => {
        if (res !== null) {
          this.datas = res.data;
          this.filterData = res.data;
          this.loading = false;
          super.setListOfAllData(this.datas);
        }
        console.log("kho hoa chat", res);
      },
      (error) => {}
    );
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe((data) => {
      this.data = data;
    });
  }

  getChemicalsList() {
    this.generalService.getChemical().subscribe(
      (res) => {
        if (res !== null) {
          this.chemicals = res;
        }
      },
      (error) => {}
    );
  }
  getMachine() {
    this.generalService.getMachine().subscribe(
      (res) => {
        if (res !== null) {
          this.machines = res;
        }
      },
      (error) => {}
    );
  }

  showModalAdd() {
    this.viewOnly = false;
    this.disableComplete = true;
    this.isVisibleAdd = true;
    this.selectedData = {
      id: 0,
      code: "",
      description: "",
      receiveType: 1,
      recipient: "",
      warehouseExportDetails: [],
      scanBarcode: this.scanBarcodeDefault,
      parcelDetailCode: "",
      receiverName: "",
      importerName: "",
    };
  }

  addDetailInput() {
    const item = {
      id: 0,
      chemicalId: 0,
      amount: 0,
      price: 0,
      totalPrice: 0,
      lotNumber: "",
      expiredDate: new Date(),
    };
    this.selectedData.warehouseExportDetails.push(item);
  }

  doSearch() {}

  showModalUpdate(data) {
    this.isEdit = true;
    this.viewOnly = false;
    this.disableComplete = false;
    this.selectedData = data;
    this.selectedData.scanBarcode = this.scanBarcodeDefault;
    this.isVisibleAdd = true;
    for (let i = 0; i < this.selectedData.warehouseExportDetails.length; i++) {
      for (
        let j = i + 1;
        j < this.selectedData.warehouseExportDetails.length;
        j++
      ) {
        if (
          this.selectedData.warehouseExportDetails[i].chemical.code ===
            this.selectedData.warehouseExportDetails[j].chemical.code &&
          this.selectedData.warehouseExportDetails[i].manufacturerCode ===
            this.selectedData.warehouseExportDetails[j].manufacturerCode &&
          this.selectedData.warehouseExportDetails[i].madeIn ===
            this.selectedData.warehouseExportDetails[j].madeIn &&
          this.selectedData.warehouseExportDetails[i].serialNumber ===
            this.selectedData.warehouseExportDetails[j].serialNumber &&
          this.selectedData.warehouseExportDetails[i].expiredDate ===
            this.selectedData.warehouseExportDetails[j].expiredDate &&
          this.selectedData.warehouseExportDetails[i].batchNumber ===
            this.selectedData.warehouseExportDetails[j].batchNumber
        ) {
          this.selectedData.warehouseExportDetails[i].amount += 1;
          this.selectedData.warehouseExportDetails.splice(j, 1);
        }
      }
    }
  }

  handleOk() {
    console.log(this.selectedData);
    if (!this.selectedData.description) {
      this.notificationService.showNotification(
        Constant.ERROR,
        "Chưa nhập mô tả phiếu"
      );
      return;
    }
    if (!this.selectedData.warehouseExportDetails.length) {
      this.notificationService.showNotification(
        Constant.ERROR,
        "Chưa nhập chi tiết phiếu xuất"
      );
      return;
    }
    this.isVisibleAdd = false;
    this.loadingButton = true;
    this.selectedData.fromWareHouseId = this.selectedWarehouseId;
    if (this.selectedData.id === 0) {
      delete this.selectedData.id;
      this.generalService.addWarehouseExport(this.selectedData).subscribe(
        (res) => {
          console.log(this.selectedData);
          this.loadingButton = false;
          console.log(res);
          if (res.ret && res.ret[0].code !== 0) {
            this.notificationService.showNotification(
              Constant.ERROR,
              res.ret[0].message
            );
          } else {
            this.disableComplete = false;
            this.notificationService.showNotification(
              Constant.SUCCESS,
              "Lưu nháp xuất điều chuyển thành công"
            );
            this.getListData();
          }
        },
        (error) => {}
      );
    } else {
      delete this.selectedData.toWareHouse;
      this.generalService.updateWarehouseExport(this.selectedData).subscribe(
        (res) => {
          this.loadingButton = false;
          console.log(this.selectedData);
          this.loadingButton = false;
          console.log(res);
          if (res.ret && res.ret[0].code !== 0) {
            this.notificationService.showNotification(
              Constant.ERROR,
              res.ret[0].message
            );
          } else {
            this.disableComplete = false;
            this.notificationService.showNotification(
              Constant.SUCCESS,
              "Cập nhật xuất điều chuyển thành công"
            );
            this.getListData();
          }
        },
        (error) => {}
      );
    }
  }

  showConfirm(id): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Bạn có muốn xóa hay không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.deleteItem(id),
    });
  }

  deleteItem(id) {
    this.generalService.deleteWarehouseExport(id).subscribe(
      (res) => {
        if (res.ret && res.ret[0].code !== 0) {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.ret[0].message
          );
        } else {
          this.notificationService.showNotification(
            Constant.SUCCESS,
            Constant.MESSAGE_DELETE_SUCCESS
          );
          this.getListData();
        }
      },
      (error) => {}
    );
  }

  deleteDetail($item) {
    this.selectedData.warehouseExportDetails =
      this.selectedData.warehouseExportDetails.filter(
        (en) => en.parcelDetailCode !== $item.parcelDetailCode
      );
  }

  showDetails(data) {
    this.selectedData = data;
    this.isVisibleAdd = true;
    this.viewOnly = true;
    console.log(data);
    // this.selectedData.warehouseExportDetails =
    //   this.selectedData.warehouseExportDetails.filter(
    //     (value, index, self) =>
    //       index ===
    //       self.findIndex(
    //         (t) =>
    //           t.chemical.code === value.chemical.code &&
    //           t.manufacturerCode === value.manufacturerCode &&
    //           t.madeIn === value.madeIn &&
    //           t.serialNumber === value.serialNumber &&
    //           t.expiredDate === value.expiredDate &&
    //           t.batchNumber === value.batchNumber
    //       )
    //   );
    for (let i = 0; i < this.selectedData.warehouseExportDetails.length; i++) {
      for (
        let j = i + 1;
        j < this.selectedData.warehouseExportDetails.length;
        j++
      ) {
        if (
          this.selectedData.warehouseExportDetails[i].chemical.code ===
            this.selectedData.warehouseExportDetails[j].chemical.code &&
          this.selectedData.warehouseExportDetails[i].manufacturerCode ===
            this.selectedData.warehouseExportDetails[j].manufacturerCode &&
          this.selectedData.warehouseExportDetails[i].madeIn ===
            this.selectedData.warehouseExportDetails[j].madeIn &&
          this.selectedData.warehouseExportDetails[i].serialNumber ===
            this.selectedData.warehouseExportDetails[j].serialNumber &&
          this.selectedData.warehouseExportDetails[i].expiredDate ===
            this.selectedData.warehouseExportDetails[j].expiredDate &&
          this.selectedData.warehouseExportDetails[i].batchNumber ===
            this.selectedData.warehouseExportDetails[j].batchNumber
        ) {
          this.selectedData.warehouseExportDetails[i].amount += 1;
          this.selectedData.warehouseExportDetails.splice(j, 1);
        }
      }
    }
  }

  handleCancel() {
    this.isVisibleAdd = false;
    this.disableComplete = true;
  }

  getRowIndex = (index, pageIndex, pageSize) =>
    index + 1 + pageSize * (pageIndex - 1);

  handleBarcode($event: any) {
    const existsItem = this.selectedData.warehouseExportDetails.find(
      (en) => en.parcelDetailCode === $event
    );
    if (existsItem) {
      this.notificationService.showNotification(
        Constant.ERROR,
        "Hóa chất đã được nhập vào chi tiết phiếu"
      );
      return;
    }
    this.generalService.getChemicalByBarCode($event).subscribe(
      (res) => {
        console.log(res);
        if (res.ret && res.ret[0].code !== 0) {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.ret[0].message
          );
        } else {
          this.selectedData.parcelDetailCode = "";
          this.selectedData.warehouseExportDetails.push(res);
        }
      },
      (error) => {}
    );
  }

  exportPDF() {
    const current_warehouse = this.warehouses.find(
      (en) => en.id === this.selectedWarehouseId
    );
    const phieuId = this.selectedData.id;
    const mainUrl =
      this.configService.getConfig().api.reportUrl + "/BridgeXLSDownload.aspx";
    const url =
      mainUrl +
      `?PhieuId=${phieuId}&report=PhieuXuatKho&WarehouseName=${current_warehouse.name}`;
    console.log(url);
    window.open(url, "_blank");
  }

  handleComplete() {
    this.generalService.completeExport(this.selectedData.id).subscribe(
      (res) => {
        if (res.isValid) {
          this.isVisibleAdd = false;
          this.getListData();
          this.notificationService.showNotification(
            Constant.SUCCESS,
            "Đã hoàn thành phiếu xuất điểu chuyển"
          );
        } else {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.errors[0].key
          );
        }
      },
      (error) => {}
    );
  }
}
